import { Discount } from '../../types/Gym';

type Props = {
  discount: Discount;
  productType: string;
};

const discountWithSign = (discount: Discount) =>
  discount.discount_percentage ? `${discount.discount_percentage}%` : '';

export const ProductDiscountMessage: React.FC<Props> = ({ discount, productType }) => {
  const message =
    productType === 'monthly' && discount.trial_days && discount.discount_percentage === 100
      ? `Start ${discount.trial_days} Day Free Trial`
      : discount.discount_percentage === 100
      ? `Free`
      : `Get ${discountWithSign(discount)} off this pass`;

  return <span>{message}</span>;
};
